import React, { memo } from 'react';
import { oneOf } from 'prop-types';

import classnames from 'classnames';

const namespace = 'ui-search-fullsnackbar-skeleton';

/**
 * Line component
 * @param {Object} props - Component props
 * @param {('small'|'large'|'extra-large')} [props.size='large'] - Size variant of the line
 * @returns {JSX.Element} Rendered line element
 */

const Line = memo(({ size = 'large' }) => (
  <div className={classnames(namespace, `${namespace}__line`, `${namespace}__line--${size}`)} />
));

Line.displayName = 'Line';

Line.propTypes = {
  size: oneOf(['small', 'large', 'extra-large']),
};

export default Line;
